import { Form, Input, Modal, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useUpdateSurveySummary } from '../../../../api/Surveys';

const { TextArea } = Input;

function EditSurveySummaryModal({ visible, closeModal, summary, surveyId }) {
  const [form] = Form.useForm();
  const { mutate: updateSurveySummary, isLoading: updateSurveySummaryLoading } =
    useUpdateSurveySummary();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ summary });
    }
  }, [form, summary, visible]);

  const onFinish = (values) => {
    updateSurveySummary(
      { surveyId, data: { summary: values.summary } },
      {
        onSuccess: () => message.success('Survey summary updated'),
        onSettled: () => closeModal(),
      },
    );
  };

  return (
    <Modal
      title="Edit survey summary"
      open={visible}
      width={600}
      onOk={() => {
        form
          .validateFields()
          .then(onFinish)
          .catch(() => {});
      }}
      okText="Update"
      onCancel={closeModal}
      confirmLoading={updateSurveySummaryLoading}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          name="summary"
          rules={[
            { required: true, message: 'Survey summary is required' },
            { whitespace: true, message: 'Survey summary cannot be blank' },
          ]}
        >
          <TextArea rows="6" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

EditSurveySummaryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  summary: PropTypes.string.isRequired,
  surveyId: PropTypes.number.isRequired,
};

export default EditSurveySummaryModal;
